import CustomButton from "components/CustomButton/CustomButton";
import DialogAlertSuccessNotify from "components/DialogAlertNotify/v2/DialogAlertSuccessNotify";
import { wait } from "utils/others";

const DialogAlertSuccessRegisterSpace = ({
    dialog, spaceName, backToCampusSpaces
}) => {
    async function hide() {
        dialog.hide();
        await wait(310);
        backToCampusSpaces();
    }
    return (
        <DialogAlertSuccessNotify
            dialog={{
                ...dialog,
                hide
            }}
            variant="secondary"
            title={`Hemos registrado el espacio ${spaceName}`}
            description="Ahora debes administrar los horarios para que los alumnos
            puedan realizar sus reservas."
            buttons={
                <CustomButton
                    text="Cerrar"
                    width="150px"
                    onClick={hide} />} />
    );
}

export default DialogAlertSuccessRegisterSpace;